export const CLIENT_DATA = (data) => {
  return [
    {
      class: 'textfield',
      name: 'origen',
      label: 'Nº cliente',
      value: data.id,
      disabled: true,
      sm: 6,
      xs: 12,
    },
    {
      class: 'textfield',
      name: 'cuit',
      label: 'CUIT/CUIL/DNI',
      value: data.cuit,
      disabled: true,
      sm: 6,
      xs: 12,
    },
    {
      class: 'textfield',
      name: 'nombre',
      label: 'Razón social',
      value: data.nombre,
      disabled: true,
      sm: 6,
      xs: 12,
    },
    {
      class: 'textfield',
      name: 'provincia',
      label: 'Provincia',
      value: data.provincia,
      sm: 6,
      xs: 12,
      disabled: true,
    },
    {
      class: 'textfield',
      name: 'localidad',
      label: 'Localidad',
      value: data.localidad,
      disabled: true,
      sm: 6,
      xs: 12,
    },
    {
      class: 'textfield',
      label: 'Dirección',
      name: 'domicilio',
      value: data.domicilio,
      sm: 6,
      xs: 12,
      disabled: true,
    },
  ]
}
